import axios from 'axios'
import { authHeader } from '@/helpers'
import config from '@/config'


const { API_URL } = config

export const promoService = {
  getCode
}

async function getCode(code) {
  let url = `${API_URL}/api/promoLookup?promoCode=${code}`
  let opts = {
    url
  }
  let resp = await axios(opts)
  return resp.data

}